import plataformaApi from '@/services/plataforma/default';

export default {
  fetchUsers({ rootState }) {
    return plataformaApi.get('academic/courses/enrollment/user')
      .then((res) => res.data.user);
  }
};
